import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { Listings } from 'containers/AppContainer/typings';
import { IUploadedDocument } from 'containers/LawyerLegalProceedingsPage/typings';
import { get } from 'lodash';
import { useExpertReport } from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/hooks';
import ExpertReportAppeal from 'containers/common/LegalProceedings/ExpertReportAppeal';
export interface ExpertReportAppealFormProps {
  intl: IntlShape;
  listings: Listings;
  policyInfo: any;
  uploadDocument: Function;
  uploadedDocument: IUploadedDocument;
  resetUploadDocumentStore: Function;
  procedureInstance: any;
  judgementAddDocuments: any;
  expertiseReport: any;
  setProcedureInstance: Function;
  documentId: any;
  setDocumentId: Function;
  requestGetDocByDocumentumId: Function;
}

export const ExpertReportAppealForm: React.FC<ExpertReportAppealFormProps> = (
  props,
): JSX.Element => {
  const { expertReportState, setExpertReportState } = useExpertReport(
    props.judgementAddDocuments,
    props.expertiseReport,
  );
  return (
    <>
      <ExpertReportAppeal
        listings={props.listings}
        claimId={get(props.procedureInstance, 'claimId')}
        uploadDocument={props.uploadDocument}
        uploadedDocument={props.uploadedDocument}
        resetUploadedDocument={() => {}}
        expertReportState={expertReportState as any}
        setExpertReportState={setExpertReportState}
        expertReport={{} as any}
        setIsDecisionDialgOpen={() => {}}
        isDecisionDialgOpen={false}
        isManager={false}
        isAssignedLawyer={false}
        claimNumber={get(props.procedureInstance, 'claimNumber')}
        victimExpertises={[]}
        vehicleExpertises={[]}
        judgementAddDocuments={[]}
        judiciaryProcessId={get(props.procedureInstance, 'judiciaryProcessId')}
        documentId={''}
        setDocumentId={() => {}}
        requestCreateExpertiseRaport={() => {}}
        requestValidateExpertReport={() => {}}
        requestGetExpertiseRaport={() => {}}
        victims={[]}
        claim={{} as any}
        policyInfo={props.policyInfo}
        hasJom={false}
        sagisVictimInfo={null}
        sagisOpposingParties={null}
        isConsultation={false}
        imagineDocuments={[]}
        requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
      />
    </>
  );
};

export default injectIntl(ExpertReportAppealForm);
